<div class="headers-details" [ngClass]="screenClasses()">
  <div class="avatar">
    <on-ui-cover [cover]="cover"></on-ui-cover>
  </div>
  <div class="info">
    <div class="name">{{ title }}</div>
    <app-rating [stats]="teacher?.stats"></app-rating>
  </div>
</div>
